const SERVICE = "market";


const getCategories = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process("/categories",params);

module.exports = {
  getCategories,
};
